import React, { useEffect } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import BeforeAfterSlider from './BeforeAfterSlider';
import AboutSection from './AboutSection';
import ContactSection from './ContactSection';
import Footer from './Footer';
import Snowflakes from './Snowflakes';
import ChatWidget from './ChatWidget';

const LandingPage = () => {
  return (
    <>
      <Snowflakes />
      <Header />
      <HeroSection />
      <ServicesSection />
      <BeforeAfterSlider />
      <AboutSection />
      <ContactSection />
      <Footer />
      <ChatWidget />
    </>
  );
};

export default LandingPage;